// const products = [
//   { id: 1, name: "Laptop", price: 800, description: "High performance laptop" },
//   { id: 2, name: "Phone", price: 500, description: "Latest smartphone" },
//   { id: 3, name: "Headphones", price: 120, description: "Noise cancelling" }
// ];

const products = [
  {
    id: 1,
    name: "Sri Vasavi Florals",
    rating: 4.9,
    verified: true,
    description: "Traditional South Indian Wedding Garlands",
    distance_km: 2.4,
    bookings: "150+",
    starting_price: 120.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
    ],
    floralComposition: [
      "Premium Ooty Roses",
      "Madurai Malligai (Jasmine)",
      "Golden Thai Lilies",
      "Fresh Tulsi Springs"
    ],
    colorTheme: [
      "red",
      "pink",
      "yellow",
      "white"
    ],
    garlandLength: [
      "Standard (5.5 ft)",
      "Extended (6.5 ft) +$40",
      "Royal Grandeur (8 ft) +$90"
    ]
  },
  {
    id: 2,
    name: "Royal Jasmine Crafts",
    rating: 4.8,
    verified: true,
    description: "Exotic Jasmine & Rose Phuang Malai",
    distance_km: 5.1,
    bookings: 89,
    starting_price: 85.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",      
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
    ],
    floralComposition: [
      "Premium Ooty Roses",
      "Madurai Malligai (Jasmine)",
      "Golden Thai Lilies",
      "Fresh Tulsi Springs"
    ],
    colorTheme: [
      "red",
      "pink",
      "yellow",
      "white"
    ],
    garlandLength: [
      "Standard (5.5 ft)",
      "Extended (6.5 ft) +$40",
      "Royal Grandeur (8 ft) +$90"
    ]
  },
  {
    id: 3,
    name: "Bloom & Crown",
    rating: 5.0,
    verified: true,
    description: "Bespoke Floral Crowns & Accessories",
    distance_km: 1.2,
    bookings: 210,
    starting_price: 45.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA1qICqM-Pj4N7xxxUNbfhJ5PRtdAg4Lgzias5Lj0TZIol1YOUfOZ3Ks-fRMvjH5JMQSLCSZi3LRO-IFWHxO3VliZvf2usDB2C3d3RjEYgZ68BfuPBkvuN5y2lhRZfaexFyugo20Zo7jgjUb55jmN_37Mk-f4Kr9S6-spGnD0zYheMrRP6-E47xrepwVJjpVj067YFolRLK598tyyD5l5u9k9VEcizdq6O2zpSByxInojdSZPE3b0FBSN23v7C1v9hf9NWEoIrOBeSp",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA1qICqM-Pj4N7xxxUNbfhJ5PRtdAg4Lgzias5Lj0TZIol1YOUfOZ3Ks-fRMvjH5JMQSLCSZi3LRO-IFWHxO3VliZvf2usDB2C3d3RjEYgZ68BfuPBkvuN5y2lhRZfaexFyugo20Zo7jgjUb55jmN_37Mk-f4Kr9S6-spGnD0zYheMrRP6-E47xrepwVJjpVj067YFolRLK598tyyD5l5u9k9VEcizdq6O2zpSByxInojdSZPE3b0FBSN23v7C1v9hf9NWEoIrOBeSp",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
    ],
    floralComposition: [
      "Premium Ooty Roses",
      "Madurai Malligai (Jasmine)",
      "Golden Thai Lilies",
      "Fresh Tulsi Springs"
    ],
    colorTheme: [
      "red",
      "pink",
      "yellow",
      "white"
    ],
    garlandLength: [
      "Standard (5.5 ft)",
      "Extended (6.5 ft) +$40",
      "Royal Grandeur (8 ft) +$90"
    ]
  },
  {
    id: 4,
    name: "Heritage Blooms",
    rating: 4.7,
    verified: true,
    description: "Temple Puja Garlands & Door Torans",
    distance_km: 3.8,
    bookings: 320,
    starting_price: 35.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuDvwkOlkrqf9ahhKQwDNjef1iNAZfIKl-MNcWBAQL4R2MNYpQpV9jCl6DbZW2Zt4eCPL6UzOxuOP2QBE2-sTpALQAAyeHnlBwLvThHGtpseprcolEreLxkw97st4rB_RkzGUg5cntPOu8ZjSMStYYnlhXhznCHuyd0b3oz81uWXTztaTU9WYeYWVJxLjKvH_KrqS9rnaVxzfzWPuGE8l4OXOSm3RMg34hPBimbWme2cdI3tpnewlOGd36cXl6Ea0q1HefEEUol0fzzn",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuDvwkOlkrqf9ahhKQwDNjef1iNAZfIKl-MNcWBAQL4R2MNYpQpV9jCl6DbZW2Zt4eCPL6UzOxuOP2QBE2-sTpALQAAyeHnlBwLvThHGtpseprcolEreLxkw97st4rB_RkzGUg5cntPOu8ZjSMStYYnlhXhznCHuyd0b3oz81uWXTztaTU9WYeYWVJxLjKvH_KrqS9rnaVxzfzWPuGE8l4OXOSm3RMg34hPBimbWme2cdI3tpnewlOGd36cXl6Ea0q1HefEEUol0fzzn",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
    ],
    floralComposition: [
      "Premium Ooty Roses",
      "Madurai Malligai (Jasmine)",
      "Golden Thai Lilies",
      "Fresh Tulsi Springs"
    ],
    colorTheme: [
      "red",
      "pink",
      "yellow",
      "white"
    ],
    garlandLength: [
      "Standard (5.5 ft)",
      "Extended (6.5 ft) +$40",
      "Royal Grandeur (8 ft) +$90"
    ]
  },
  {
    id: 5,
    name: "Pure White Studio",
    rating: 4.9,
    verified: true,
    description: "Elegant White Lily Garlands & Decor",
    distance_km: 6.5,
    bookings: 64,
    starting_price: 150.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuBqFoN0Q4dIZyVcowJ77QYwTbxAbvsFCLTgk8ROQw9143-wg3NqbYUNUws38TOyj_KOM2J0rZwXtA95368wXggLbllW574HCSk4m0x9wAyIts_U2mCqJhIrnf7120MxIroJNzf0c3YDKfy9BSMt59t13WYU3yIlCvuYzdKMweHlKW3EHCdEAtbmdp0TYB8PcsKuhS-T5CLo8c1LvmW3CH-J6aBuOYC5MAFNScnGIgX-8sDb0TEzuTySax9tYFmwcQQr_oMrF_t2O7a_",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuBqFoN0Q4dIZyVcowJ77QYwTbxAbvsFCLTgk8ROQw9143-wg3NqbYUNUws38TOyj_KOM2J0rZwXtA95368wXggLbllW574HCSk4m0x9wAyIts_U2mCqJhIrnf7120MxIroJNzf0c3YDKfy9BSMt59t13WYU3yIlCvuYzdKMweHlKW3EHCdEAtbmdp0TYB8PcsKuhS-T5CLo8c1LvmW3CH-J6aBuOYC5MAFNScnGIgX-8sDb0TEzuTySax9tYFmwcQQr_oMrF_t2O7a_",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
    ]
  },
  {
    id: 6,
    name: "Artistic Petals",
    rating: 4.6,
    verified: true,
    description: "Luxury Rose Petal Wedding Carpets",
    distance_km: 8.2,
    bookings: 42,
    starting_price: 200.0,
    currency: "USD",
    image:
      "https://lh3.googleusercontent.com/aida-public/AB6AXuDlkOcuvaCEnUjLOtaZVa07aXctYQTrus_gE6jIyrt0aYEgnIXKgobb9bR7fgEpzeiT-YCPl_VU5qSsfgnqOhdTkTNpn9QAEIQLWR0l-7haT8SXTs9OF1kpZ39RcedIl6se46zl5lF-p6A-SYdFinceUV_BvzoZuDcaPTVPkIObGP5NcCF9BZCny07j462WhdgS_TJB2GmxhhG8xxkqFjsjuJqdyIb49MiKdb0u-aD0anhj9EmPm6UHbpW1g3pw886Dh3_GZnAcVYgq",
    imgVariants: [
      "https://lh3.googleusercontent.com/aida-public/AB6AXuDlkOcuvaCEnUjLOtaZVa07aXctYQTrus_gE6jIyrt0aYEgnIXKgobb9bR7fgEpzeiT-YCPl_VU5qSsfgnqOhdTkTNpn9QAEIQLWR0l-7haT8SXTs9OF1kpZ39RcedIl6se46zl5lF-p6A-SYdFinceUV_BvzoZuDcaPTVPkIObGP5NcCF9BZCny07j462WhdgS_TJB2GmxhhG8xxkqFjsjuJqdyIb49MiKdb0u-aD0anhj9EmPm6UHbpW1g3pw886Dh3_GZnAcVYgq",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA-5FKBnOzYkM43volrxnIB3CjIfUqGrKIKqur7XwApRmFsmLDdgl7ivwOtgzeiQA5zFI191vl8PF0_YHaOsoICrj3dhzQlpxnQ64ZDdW7_hj3CLuoDXwP-erWxsczMEUFE_p9MSmeLaycPc9NrY-5vEWxAxDyLX6qZe1OMSVRqEewrNlxsrkeZNK3qEPEmHOjOqaYDifiIEaecy4CrQyysI0tX3m_j9PYueGaibEdISo433FF09UIoGhKCdfYl5FSNC8ZH6qY1zE5s",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCYob_nwG45qwKxbgjG5aQ2CJMOcKT55l_lWvcqG5DhQsSXHeEA41-PpO9gzx2w6qt10aeJIU6IchmsOTZ0V5VcIJMYnP6ueH1ZWVaoVqCo2cckY6F1tmx7ryLvRA10exZtrCLQItAt8EpbE8lNRkR_AcCdzeffnaHk4AaC1s6AOTsftgeaewe1jeoGxNSh21eNtTLKlfKoK8V5akCBZj544ShjaxBMUHylrotcv-qcBdiMGagZAc6T_lF38Hof4_NFgzaofbOIPvf9",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuA9YnIeBTKJPEXiOVggDRTWJlo8dPO6CNZdwuX-PuC05akYpwQZvktvOLlxCoP2KoNDu0VGedes6qeK79Sb-Wzvl0zen0OrDsafKUX2ztClZJ9NNkpS9KyC9f0JsuWZj6NNY5bmNu0pXhHSswuhcGL5J84LtGo-6xsALRGWKlW5hTb9LIWv7GuuZMahPFbtl3zH0wu2_Y2AaKBSOOGwu23DJ2zhRMxkYE3GGdPiDEjhV9yiqrVosjyqHrUxRZ5q5FuHf0xavOeJdD9X",
      "https://lh3.googleusercontent.com/aida-public/AB6AXuCjDK3r4I4dzl9ntdP-jb6cJxrZKAaQ7RL0ggNQcanq5qxg1rgd0i1CiDC0qvQJd8HwqY_4w8DsutUQPcnt581pZ6ZoGHqT_AMcmu0jpk8qQPBEK5VJgfD2K55guocsN-BtmHG1mlgrPjJ7K8jZQytNUTBSF2uufUWDOe8ejyr3wd6r2h7ay5k5O6y7hh-UAbkKDMUYNiow45IZPsZXwQHAYxOXdTW3y5QKD90MylyKPmuJeEhmk_lHp7Gv8pEAac4mkm869yy75uCt",
    ],
    floralComposition: [
      "Premium Ooty Roses",
      "Madurai Malligai (Jasmine)",
      "Golden Thai Lilies",
      "Fresh Tulsi Springs"
    ],
    colorTheme: [
      "red",
      "pink",
      "yellow",
      "white"
    ],
    garlandLength: [
      "Standard (5.5 ft)",
      "Extended (6.5 ft) +$40",
      "Royal Grandeur (8 ft) +$90"
    ]
  },
];

export default products;
